import _ from 'lodash';
import { paymentFieldsMaxLengths } from '../constants/companies';

/**
 * @param {object} data
 * @return {object}
 * */
export const extractCompanyPayload = data => {
  const {
    address,
    city,
    state,
    zip,
    net_terms,
    cc_invoices,
    is_individual,
    is_cc_exempt,
    use_custom_rate,
    company_name,
    allow_1099m_workers,
    is_lta,
    checkin_verification_allowed,
    owner_id,
    hide
  } = data;
  return {
    address,
    city,
    state,
    zip,
    net_terms,
    is_individual,
    is_cc_exempt,
    use_custom_rate,
    company_name,
    allow_1099m_workers,
    cc_invoices: cc_invoices ? encodeCCList(cc_invoices) : cc_invoices,
    is_lta,
    checkin_verification_allowed,
    owner_id,
    hide
  };
};

/**
 * @param {object} data
 * @param {string} data.name
 * @return {object}
 * */
export const extractDepartmentPayload = ({ name }) => ({ name });

/**
 * @param {string} input
 * @return {string}
 * */
export const encodeCCList = input => input.replace(/\s/mg, '').split(',').join(';');

/**
 * @param {string} input
 * @return {string}
 * */
export const decodeCCList = input => input.replace(/;/mg, ', ');

/**
 * @param {object} user
 * @param {array} companies
 * @return {object}
 * */
export function getUserCompany (user, companies) {
  if (!user || !companies || !companies.length) {
    return null;
  }

  return companies.find(company => company.id === user.company_id) || null;
}

/**
 * @param {object} user
 * @param {array} departments
 * @return {object}
 * */
export function getUserDepartment (user, departments) {
  if (!user || !departments || !departments.length) {
    return null;
  }

  return departments.find(dept => dept.id === user.department_id) || null;
}

export function extractPaymentCardData (cardInfo) {
  return _.get(cardInfo, ['sources', 'data', '0']);
}

/**
 *
 * @param {string} cardNumber
 * @returns {string}
 *
 * */
export const visuallyFormatCardNumber = cardNumber =>
  cardNumber.split('').filter(char => !/\D/.test(char)).join('').replace(/(\d{4})/g, '$1 ').trim();

/**
 * @see https://en.wikipedia.org/wiki/Payment_card_number
 * @description
 *   On UI we are formatting a credit card number for better readability like this: 4242 4242 4242 4242
 *   The maximum credit card number length is 19
 *   So we have to strip out whitespaces to get correct maximum input value
 *
 * @param {string} inputValue
 * @return {number}
 */
export function getCardNumberFieldMaxLength (inputValue) {
  return paymentFieldsMaxLengths.cardNumber + inputValue.replace(/\S/g, '').length;
}



// WEBPACK FOOTER //
// ./src/helpers/companies.js